import React from 'react';
import DNS from './DNS';

const DNSContainer = () => {
  return <DNS />;
};
export default DNSContainer;
